import { Module, ActionContext } from 'vuex';
import { RootStoreState } from '@/store';
import ApiServiceWrapper from '@/shared/api-request.service';

export interface PsaHubStoreState {
  gradientDetail: {
    showTab: String,
    displayText: String,
    showConfigure: String,
    showManage: String,
    showLaunch: String,
    isOrgEnabled: String,
    availableUsers: [],
    assignedUsers: [],
  };
}

export default {
  state: {
    gradientDetail: {
      showTab: '',
      displayText: '',
      showConfigure: '',
      showManage: '',
      showLaunch: '',
      isOrgEnabled: '',
      availableUsers: [],
      assignedUsers: [],
    },
  },
  mutations: {
    setGradientDetail(state, payload) {
      state.gradientDetail = payload;
    },
  },
  actions: {
    async manageGradient(context: ActionContext<PsaHubStoreState, RootStoreState>, payload: any) {
      context.commit('startLoading', null, { root: true });
      const endpoint = 'users/manage-gradient';
      const res = await ApiServiceWrapper.post(endpoint, payload);
      context.commit('setGradientDetail', res.content);
      return res;
    },
  },
  getters: {
    getGradientDetails : state => state.gradientDetail,
    isShowTab: state => state.gradientDetail.showTab === 'YES',
    isShowLaunch: state => state.gradientDetail.showLaunch === 'YES',
    isShowManage: state => state.gradientDetail.showManage === 'YES',
    isOrgEnabled: state => state.gradientDetail.isOrgEnabled === 'YES',
    isShowConfigure: state => state.gradientDetail.showConfigure === 'YES',
    getDisplayText: state => state.gradientDetail.displayText,
    getAvailableUsers: state => state.gradientDetail.availableUsers,
    getAssignedUsers: state => state.gradientDetail.assignedUsers,
  },
  namespaced: true,
} as Module<PsaHubStoreState, RootStoreState>;
